export default "__VITE_ASSET__CA8Ol$lH__"